// extracted by css-extract-rspack-plugin
module.exports =  {"error":"ErrorMessage__error--VtV7r"};